import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import getClassNameFactory from "../../../../utilities/classNames";
import ArrowRightIcon from "@dcl/icons/esm/ui/arrow-right";

var NavItem = function NavItem(_ref) {
  var href = _ref.href,
      onClick = _ref.onClick,
      summary = _ref.summary,
      title = _ref.title,
      onKeyDown = _ref.onKeyDown,
      modifier = _ref.modifier;
  var getClassName = getClassNameFactory("GlobalHeaderNavItem");
  var LinkElementType = href ? "a" : "button";
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      modifiers: modifier ? modifier : classNames({
        summary: summary
      })
    })
  }, /*#__PURE__*/React.createElement(LinkElementType, {
    className: getClassName({
      descendantName: "link"
    }),
    href: href,
    onClick: onClick,
    onKeyDown: onKeyDown,
    role: "menuitem"
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "linkText"
    })
  }, title), summary ? /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "linkIcon"
    })
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, null)) : null));
};

NavItem.propTypes = {
  /**
   * The destination that this `NavItem` links to
   */
  href: PropTypes.string,

  /**
   * On click
   */
  onClick: PropTypes.func,

  /**
   * Whether or not this is a summary item, like "All Products ->"
   */
  summary: PropTypes.bool,

  /**
   * The title of this `NavItem`
   */
  title: PropTypes.node.isRequired,

  /**
   * onKeyDown event handler for menu item element
   */
  onKeyDown: PropTypes.func,

  /**
   * modifier : gets the element's state from the parent component
   */
  modifier: PropTypes.string
};
NavItem.displayName = "GlobalHeader.NavItem";
export default NavItem;